export type WorkflowUrlRole = 'translate' | 'prompt_enhance';

export const WORKFLOW_URL_ROLE_ENTRIES = [
  [1, 'translate'],
  [2, 'prompt_enhance'],
] as const satisfies readonly (readonly [number, WorkflowUrlRole])[];

export const WORKFLOW_URL_ROLES: Readonly<Record<number, WorkflowUrlRole>> =
  Object.fromEntries(WORKFLOW_URL_ROLE_ENTRIES);

/**
 * Display-only URL role convention. Keep this mapping synchronized with the
 * runtime dispatch hardcodes in BigPromptEditorWidget and useGenerationDispatch.
 */
export function getWorkflowUrlRole(urlIndex: number): WorkflowUrlRole | null {
  return WORKFLOW_URL_ROLES[urlIndex] ?? null;
}
